import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      toast.error('OAuth authentication failed');
      navigate('/login');
      return;
    }

    if (token) {
      localStorage.setItem('auth_token', token);
      refreshUser().then(() => {
        toast.success('Logged in successfully!');
        navigate('/dashboard');
      });
    } else {
      toast.error('No token received');
      navigate('/login');
    }
  }, [searchParams, navigate, refreshUser]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Authenticating...</h1>
        <p>Please wait while we log you in.</p>
      </div>
    </div>
  );
}
